const CHECK_ANIMATION_DURATION_DEFAULT_MS = 2600;
export const CHECK_ANIMATION_DURATION_MS = 4000;
export const CHECK_ANIMATION_SPEED =
    CHECK_ANIMATION_DURATION_DEFAULT_MS / CHECK_ANIMATION_DURATION_MS;
export const CHECK_ANIMATION_BUFFER_MS = 500;
